<template>
  <SimpleTextPopup
    :title="$t('labelInvoiceDetailsTitle', { clientName: client.clientName ? client.clientName + ' ' : '' })"
    v-model="value"
    @popupClose="$emit('input', false)"
    :hideRgtBtn="true"
    :outsideScrollToBottom="outsideScrollToBottom"
    medium
  >
    <template v-slot:input>
      <v-layout row justify-space-around>
        <v-flex xs6 md6 xl6 lg4>
          <DatePicker
            :label="$t('date')"
            range
            v-model="dates"
            :min="dateMin"
            :max="dateMax"
          >
          </DatePicker>
        </v-flex>
        <!-- <v-flex xs6 md3 xl2 lg2>
          <v-menu
            ref="endDatePicker"
            lazy
            :close-on-content-click="false"
            v-model="endDatePicker"
            transition="scale-transition"
            offset-y
            full-width
            :nudge-right="40"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :label="$t('date')"
                v-model="endDate"
                prepend-icon="event"
                v-on="on"
                readonly
              ></v-text-field>
            </template>
            <v-date-picker :max="dateMax" v-model="endDate" @input="endDatePicker = false"></v-date-picker>
          </v-menu>
        </v-flex> -->
        <v-flex md3 xl2 lg2><v-btn dark color="primary" :disabled="!isClient" :loading="isGenerateLoading" @click.stop="generateFile(tenantKey, dates[0], dates[1])">{{ $t('generate') }}</v-btn></v-flex>
        <v-flex md3 xl2 lg2><v-btn dark color="primary" v-if="isModeLabel" :loading="freshLoading" @click.stop="freshTransactions">{{ $t('fresh') }}</v-btn></v-flex>
        <!-- <v-flex md4 xl2 lg3>
          <v-checkbox :label="$t('isSplitInvoice')" v-model="isSplitInvoice"></v-checkbox>
        </v-flex> -->
        <v-flex align-self-center class="red--text font-weight-bold text-xs-left">
          {{errorMessage}}
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="isModeLabel ? apiExportTransactions : client.labelInvoices || []"
        class="my-1 levation-2 myDense"
        :pagination.sync="pagination"
        :rows-per-page-items="rowPerPage"
      >
        <template v-slot:items="props">
          <td class="subheading">{{ String(props.item.file).split('/').pop()}}</td>
          <td class="text-xs-left">{{ toDateYYYYMMDDHHmm(new Date(props.item.createTime)) }}</td>
          <td class="text-xs-right">
            <v-layout row>
              <v-flex><v-btn :disabled="!isClient" flat dark icon color="primary" @click.stop="downloadFile(props.item.file, String(props.item.file).split('/').pop(), props.item.fileUrl, props.item)"><v-icon>file_download</v-icon></v-btn></v-flex>
              <v-flex><v-btn v-if="!isModeLabel" :disabled="!isClient || (isDeleteLoading && currentDeleteFile != props.item.file)" flat dark icon color="primary" :loading="isDeleteLoading && currentDeleteFile === props.item.file" @click.stop="deleteFile(tenantKey, props.item.file)"><v-icon>delete</v-icon></v-btn></v-flex>
            </v-layout>
          </td>
        </template>
      </v-data-table>
    </template>
  </SimpleTextPopup>
</template>

<script>
import { timeTools } from '@/utils/tools'
import SimpleTextPopup from './SimpleTextPopup'
import { mapActions } from 'vuex'
import DatePicker from './DatePicker.vue'

export default {
  name: 'LabelInvoiceDetails',
  components: {
    SimpleTextPopup,
    DatePicker
  },
  mixins: [timeTools],
  data () {
    return {
      popupToBottom: false,
      headers: [
        { text: this.$t('fileName'), width: '60%', align: 'left', sortable: true, value: 'file' },
        { text: this.$t('createTime'), align: 'left', sortable: true, value: 'createTime' },
        { text: this.$t('actions'), width: '10%', value: 'note', align: 'center', sortable: false }
      ],
      isDeleteLoading: false,
      currentDeleteFile: '',
      isGenerateLoading: false,
      startDate: new Date(new Date().toISOString().slice(0, 7)).toISOString().slice(0, 10),
      endDate: new Date(new Date().getTime() - 60 * 60 * 1000 * 24).toISOString().slice(0, 10),
      startDatePicker: false,
      endDatePicker: false,
      dates: [
        new Date(new Date().toISOString().slice(0, 7)),
        new Date(new Date().getTime() - 60 * 60 * 1000 * 24)
      ],
      pagination: {
        sortBy: 'createTime',
        descending: true
      },
      rowPerPage: [5, 10, {text: this.$t('all'), value: -1}],
      errorMessage: '',
      isSplitInvoice: true,
      freshLoading: false,
      apiExportTransactions: []
    }
  },
  computed: {
    dateMin () {
      const endDate = this.dates[1]
      const startDate = this.dates[0]
      const monthTime = 365 * 60 * 60 * 24 * 1000
      const lastYearTime = new Date(new Date().getTime() - monthTime).setDate(0)
      if (startDate && endDate) return new Date(lastYearTime).toISOString()
      if (startDate) {
        const monthTime = 31 * 60 * 60 * 24 * 1000
        const time = startDate.getTime() - monthTime
        return new Date(Math.max(+new Date(time), lastYearTime)).toISOString()
      }
      return new Date(lastYearTime).toISOString()
    },
    dateMax () {
      const endDate = this.dates[1]
      const startDate = this.dates[0]
      const now = new Date()
      if (startDate && endDate) return new Date(now.getTime() - 60 * 60 * 1000 * 24).toISOString()
      if (startDate) {
        const monthTime = 31 * 60 * 60 * 24 * 1000
        const time = startDate.getTime() + monthTime
        return now.getTime() < time ? new Date(now.getTime() - 60 * 60 * 1000 * 24).toISOString() : new Date(time).toISOString()
      }
      return new Date(now.getTime() - 60 * 60 * 1000 * 24).toISOString()
    },
    isModeLabel () {
      return Boolean(this.selectedClientInfo && (this.selectedClientInfo.apiKey || this.selectedClientInfo.orgKey))
    },
    systemBalances () {
      return this.$store.getters.systemBalances
    },
    client () {
      return this.systemBalances.find(({clientKey}) => clientKey === this.tenantKey) || {}
    },
    isClient () {
      return !!(this.client || {}).clientKey
    }
  },
  methods: {
    outsideScrollToBottom (flag) {
      this.popupToBottom = flag
    },
    async downloadFile (fullPath, name, fileUrl, fileData) {
      if (this.isModeLabel) {
        window.open(fileUrl)
        return
      }
      if ((fileData && fileData.url)) {
        window.open(fileData.url)
        return
      }
      await this.$store.dispatch('downloadFile', {
        fullPath,
        name
      })
    },
    async deleteFile (tenantKey, file) {
      if (!confirm(this.$t('confirmWantToDelete'))) return
      this.isDeleteLoading = true
      this.currentDeleteFile = file
      await this.$store.dispatch('deleteLabelInvoice', {
        tenantKey,
        file,
        labelInvoices: this.client.labelInvoices
      }).catch(e => console.error(e))
      this.isDeleteLoading = false
      this.currentDeleteFile = ''
    },
    async generateFile (tenantKey, startDate, endDate) {
      this.isGenerateLoading = true
      this.errorMessage = ''
      const startDateTimestamp = new Date(startDate)
      const endDateTimestamp = new Date(endDate)

      if (endDateTimestamp - startDateTimestamp > 31 * 86400000) {
        alert(this.$t('invoicePeriodExceed'))
      } else {
        const result = await this.$store.dispatch('generateLabelInvoice', {
          tenantKey,
          startDate: this.toDateYYYYMMDD(new Date(startDate.toISOString().slice(0, 10))),
          endDate: this.toDateYYYYMMDD(new Date(endDate.toISOString().slice(0, 10))),
          isSplitInvoice: this.isSplitInvoice,
          companyName: this.client.companyName
        }).catch(e => {
          this.errorMessage = e.message
        })
        const { status, message } = result.data
        let msg = `export status is ${status}`
        if (message) msg += `, ${message}`
        alert(msg)
      }
      this.isGenerateLoading = false
    },
    async freshTransactions () {
      try {
        this.freshLoading = true
        const data = await this.getApiExporttransactionsList({ tenantKey: this.tenantKey })
        console.log(data)
        this.apiExportTransactions = data?.data
        this.freshLoading = false
      } catch (err) {
        console.log(err)
        this.freshLoading = false
      }
    },
    ...mapActions(['getApiExporttransactionsList'])
  },
  props: {
    value: Boolean,
    tenantKey: String,
    selectedClientInfo: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LabelInvoiceDetails.vue